
export function setGallery(state, data) {
  state.gallery = data
}

export function setIrSaving(state, data) {
    state.irSaving = data
}

export function setWidgetStructure(state, data) {
    state.widgetStructure = data
}
export function setIrSavingData(state, data) {
    state.irSavingData = data
}

export function setIrLoadingReportData(state, data) {
    state.irLoadingReportData = data
}




